/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

document.addEventListener("DOMContentLoaded", function () {

  const $priceDom = $('#sp_price1');
  const $cPriceDom = $('#sp_price2');
  const $offPriceDom = $('.sp-price-group .sp-p span');
  const $numDom = $('#calcNumber');
  
  const productData = window.product || [];

  /** 获取当前选中的变量 */
  function getCur() {
    const opts = {
      option1: $('#sp-opt-group1 div.active').attr('data-val'),
      option2: $('#sp-opt-group2 div.active').attr('data-val'),
      option3: $('#sp-opt-group3 div.active').attr('data-val')
    };

    return productData.find(item => {
      return (!opts.option1 || item.option1 == opts.option1) &&
             (!opts.option2 || item.option2 == opts.option2) &&
             (!opts.option3 || item.option3 == opts.option3);
    });
  }

  /** 更新价格显示 */
  function changePrice() {
    const curVariant = getCur();
    if (!curVariant) return;

    const num = parseInt($numDom.val()) || 1;
    
    // 识别当前页面使用的小数点符号
    const currentText = $priceDom.text().trim();
    const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/);
    
    const decimalSeparator = decimalMatch ? decimalMatch[1] : '.'; 
    const decimalLength = decimalMatch ? decimalMatch[2].length : 0; 

    // 格式化输出
    const formatValue = (cents) => {
      let val = (cents * num / 100).toFixed(decimalLength);
      if (decimalSeparator === ',') {
        val = val.replace('.', ',');
      }
      return val;
    };

    const price = formatValue(curVariant.price);
    const compare = formatValue(curVariant.compare_at_price);
    
    // 计算折扣
    let offPercent = 0;
    if (curVariant.compare_at_price > curVariant.price) {
      offPercent = 100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100);
    }

    const priceRegex = /\d+(?:[.,]\d+)*/;
    const offRegex = /(\d+)(?=(?:<[^>]+>|\s)*%)/g;

    const updateHTML = ($el, regex, value) => {
      if ($el && $el.length) {
        const text = $el[0].textContent.trim();
        const newHtml = text.replace(regex, value);
        if ($el.html() !== newHtml) {
          $el.html(newHtml);
        }
      }
    };

    updateHTML($priceDom, priceRegex, price);
    updateHTML($cPriceDom, priceRegex, compare);
    updateHTML($offPriceDom, offRegex, offPercent);
  }
  
  // 绑定选项点击事件
  $(document).on('click', '.sp-option', function() {
      setTimeout(changePrice, 10);
  });

  $('.sp_buy_now').click(function () {

    let num = $numDom.val();
    let id = getCur().id;
    window.location.href = '/cart/' + id + ':' + num;

  });


  let spImgList = [];
  
  let sp_price1 = 28.99;
  let sp_price2 = 57.98;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }
  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice();
    
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice();
    
  });

   var imgArr = [// 目标商城需要展示的产品图
        'https://cdn.shopify.com/s/files/1/0624/1268/5483/files/p1-img.png', 'https://cdn.shopify.com/s/files/1/0624/1268/5483/files/p1-img-2.png', 'https://cdn.shopify.com/s/files/1/0624/1268/5483/files/p2-img.png', 'https://cdn.shopify.com/s/files/1/0624/1268/5483/files/p2-img-2.png',
        'https://cdn.shopify.com/s/files/1/0624/1268/5483/files/p3-img.png', 'https://cdn.shopify.com/s/files/1/0624/1268/5483/files/p3-img-2.png', 'https://cdn.shopify.com/s/files/1/0877/3284/6913/files/3_-8in_200mm-3.jpg?v=1775817021', 'https://cdn.shopify.com/s/files/1/0877/3284/6913/files/3_-9in_230mm-3.jpg?v=1775817021',
        'https://cdn.shopify.com/s/files/1/0877/3284/6913/files/6_-6in_150mm.jpg?v=1775817021', 'https://cdn.shopify.com/s/files/1/0877/3284/6913/files/6_-7in_180mm.jpg?v=1775817021', 'https://cdn.shopify.com/s/files/1/0877/3284/6913/files/6_-8in_200mm.jpg?v=1775817021', 'https://cdn.shopify.com/s/files/1/0877/3284/6913/files/6_-9in_230mm.jpg?v=1775817021',
        'https://cdn.shopify.com/s/files/1/0877/3284/6913/files/6_-6in_150mm-3.jpg?v=1775817021', 'https://cdn.shopify.com/s/files/1/0877/3284/6913/files/6_-7in_180mm-3.jpg?v=1775817021', 'https://cdn.shopify.com/s/files/1/0877/3284/6913/files/6_-8in_200mm-3.jpg?v=1775817021', 'https://cdn.shopify.com/s/files/1/0877/3284/6913/files/6_-9in_230mm-3.jpg?v=1775817021',
 ]

  $(".sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    let colorOptions = $(".sp-opt-group1 .sp-option.active").index();
    let numOptions = $(".sp-opt-group2 .sp-option.active").index();
    let typeOptions = $(".sp-opt-group3 .sp-option.active").index();
    let _index = colorOptions +numOptions * 2;
    console.log(_index)
    // _swiper.slideToLoop(_index);
    $('.sp_product_part .sp-img-wrap .swiper-slide.swiper-slide-active .sp-img-p').attr('src', imgArr[_index])
  });

  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function renderCutDownTime(cutDownTimeText) {
    $("[data-countdown='hour']").html(cutDownTimeText.hour);
    $("[data-countdown='minute']").html(cutDownTimeText.minute);
    $("[data-countdown='second']").html(cutDownTimeText.second);
  }

  function initCutDownTime() {
    setupNewCountdown();
    renderCutDownTime(cutDownTime());
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      renderCutDownTime(cutDownTimeText);
    }, 1000);
  }

  initCutDownTime();

  // 初始化 sp-num2 和 sp-num4 的显示状态
  $(".sp-num2, .sp-num4").hide(); // 先隐藏所有
  let initialNumOptions = $(".sp-opt-group2 .sp-option.active").index();
  if (initialNumOptions === 0) {
    $(".sp-num2").show(); // 默认显示 X2
  } else if (initialNumOptions === 1) {
    $(".sp-num4").show(); // 显示 X4
  }

  new Swiper(".sp-swiper-fade-top", {
    spaceBetween: 10,
    effect: "fade",
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  });

  // // 按钮轮播
  new Swiper(".sp-btn-loop", {
    spaceBetween: 10,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      reverseDirection: true,
    },
    loop: true,
  });

  new Swiper(".sp-swiper1", {
    spaceBetween: 60,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 0,
    },
    loop: true,
    speed: 6000,
    slidesPerView: "auto",
  });
  new Swiper(".sp-swiper1-m", {
    spaceBetween: 30,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 0,
    },
    loop: true,
    speed: 6000,
    slidesPerView: "auto",
  });

  // 检测是否为移动端
  var isMobile = document.body.clientWidth <= 1080;
  
  // 根据设备类型选择正确的选择器
  var swiperSelector = isMobile ? ".sp_mobile .sp-swiper3" : ".sp_pc .sp-swiper3";
  
  var swiper5Config = {
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    speed: 300,
    effect: "slide",
    loop: true,
    observer: true,
    observeParents: true,
    // pagination: {
    //   el: ".sp-pagination3",
    //   clickable: true,
    // },
  };
  
  if (isMobile) {
    // 移动端配置
    swiper5Config.slidesPerView = 1;
    swiper5Config.slidesPerGroup = 1;
    swiper5Config.spaceBetween = 0;
    swiper5Config.centeredSlides = false;
    swiper5Config.slideShadows = false;
    swiper5Config.loopAdditionalSlides = 0;
    swiper5Config.observeSlideChildren = true;
    swiper5Config.watchOverflow = false;
    swiper5Config.normalizeSlideIndex = true;
    swiper5Config.resistanceRatio = 0;
    swiper5Config.allowTouchMove = true;
  } else {
    // PC端配置：与容器左对齐，避免偏移
    swiper5Config.slidesPerView = 1;
    swiper5Config.slidesPerGroup = 1;
    swiper5Config.spaceBetween = 0;
    swiper5Config.centeredSlides = false;
    swiper5Config.slideShadows = false;
    swiper5Config.loopAdditionalSlides = 0;
    swiper5Config.observeSlideChildren = true;
    swiper5Config.watchOverflow = false;
    swiper5Config.normalizeSlideIndex = true;
    swiper5Config.resistanceRatio = 0;
  }
  
  var swiper3 = new Swiper(swiperSelector, swiper5Config);

  // 同步 sp-swiper3 与对应文案项的激活态
  function updateSpItemActive(swiperInstance) {
    if (!swiperInstance || !swiperInstance.el) return;
    var partContainer = swiperInstance.el.closest(".sp-part3");
    if (!partContainer) return;

    var itemList = partContainer.querySelectorAll(".sp-item-box .sp-item");
    if (!itemList.length) return;

    var currentIndex = swiperInstance.realIndex || 0;
    for (var i = 0; i < itemList.length; i++) {
      itemList[i].classList.toggle("sp-active", i === currentIndex);
    }
  }

  // 点击文案项时，切换到对应轮播页
  function bindSpItemClick(swiperInstance) {
    if (!swiperInstance || !swiperInstance.el) return;
    var partContainer = swiperInstance.el.closest(".sp-part3");
    if (!partContainer) return;

    var itemList = partContainer.querySelectorAll(".sp-item-box .sp-item");
    if (!itemList.length) return;

    for (var i = 0; i < itemList.length; i++) {
      (function (index) {
        itemList[index].addEventListener("click", function () {
          swiperInstance.slideToLoop(index);
        });
      })(i);
    }
  }

  bindSpItemClick(swiper3);
  updateSpItemActive(swiper3);
  swiper3.on("slideChange", function () {
    updateSpItemActive(swiper3);
  });

  var swiperSelector4 = isMobile ? ".sp_mobile .sp-swiper4" : ".sp_pc .sp-swiper4";
  var swiper4 = new Swiper(swiperSelector4, swiper5Config);
  // 同步 sp-swiper4 与对应文案项的激活态
  function updateSpItemActive4(swiperInstance) {
    if (!swiperInstance || !swiperInstance.el) return;
    var partContainer = swiperInstance.el.closest(".sp-part4");
    if (!partContainer) return;

    var itemList = partContainer.querySelectorAll(".sp-item-box .sp-item");
    if (!itemList.length) return;

    var currentIndex = swiperInstance.realIndex || 0;
    for (var i = 0; i < itemList.length; i++) {
      itemList[i].classList.toggle("sp-active", i === currentIndex);
    }
  }
  // 点击文案项时，切换到对应轮播页
  function bindSpItemClick4(swiperInstance) {
    if (!swiperInstance || !swiperInstance.el) return;
    var partContainer = swiperInstance.el.closest(".sp-part4");
    if (!partContainer) return;

    var itemList = partContainer.querySelectorAll(".sp-item-box .sp-item");
    if (!itemList.length) return;

    for (var i = 0; i < itemList.length; i++) {
      (function (index) {
        itemList[index].addEventListener("click", function () {
          swiperInstance.slideToLoop(index);
        });
      })(i);
    }
  }
  bindSpItemClick4(swiper4);
  updateSpItemActive4(swiper4);
  swiper4.on("slideChange", function () {
    updateSpItemActive4(swiper4);
  });

  var swiperSelector5 = isMobile ? ".sp_mobile .sp-swiper5" : ".sp_pc .sp-swiper5";
  var swiper5 = new Swiper(swiperSelector5, swiper5Config);
  // 同步 sp-swiper5 与对应文案项的激活态
  function updateSpItemActive5(swiperInstance) {
    if (!swiperInstance || !swiperInstance.el) return;
    var partContainer = swiperInstance.el.closest(".sp-part5");
    if (!partContainer) return;

    var itemList = partContainer.querySelectorAll(".sp-item-box .sp-item");
    if (!itemList.length) return;

    var currentIndex = swiperInstance.realIndex || 0;
    for (var i = 0; i < itemList.length; i++) {
      itemList[i].classList.toggle("sp-active", i === currentIndex);
    }
  }
  // 点击文案项时，切换到对应轮播页
  function bindSpItemClick5(swiperInstance) {
    if (!swiperInstance || !swiperInstance.el) return;
    var partContainer = swiperInstance.el.closest(".sp-part5");
    if (!partContainer) return;

    var itemList = partContainer.querySelectorAll(".sp-item-box .sp-item");
    if (!itemList.length) return;

    for (var i = 0; i < itemList.length; i++) {
      (function (index) {
        itemList[index].addEventListener("click", function () {
          swiperInstance.slideToLoop(index);
        });
      })(i);
    }
  }
  bindSpItemClick5(swiper5);
  updateSpItemActive5(swiper5);
  swiper5.on("slideChange", function () {
    updateSpItemActive5(swiper5);
  });

  new Swiper(".sp-swiper6", {
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    speed: 300,
    effect: "slide",
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".sp-pagination",
      clickable: true,
    },
  });

  new Swiper('.sp-swiper7', {
    watchSlidesProgress: !0,
    slidesPerView: 'auto',
    centeredSlides: !0,
    loop: !0,
    spaceBetween: 0,
    loopedSlides: 7,
    slidesPerGroup: 1,
    grabCursor: !0,
    autoplay: {
      delay: 2000,
      stopOnLastSlide: !1,
      disableOnInteraction: !1,
    },
    speed: 500,
    on: {
      progress: function (swiper, progress) {
        for (i = 0; i < this.slides.length; i++) {
          var slide = this.slides.eq(i),
            slideProgress = this.slides[i].progress
          let translateZ = 0
          translateZ = -15 * Math.abs(slideProgress)
          let translateX = 0
          translateX = -15 * slideProgress * (Math.abs(slideProgress) + 1)
          let scale = 0
          scale = 0.1 * Math.abs(slideProgress) + 0.9
          let rotateY = 0
          ;(rotateY = 30 * slideProgress),
            slide.transform(
              'translateX(' +
                translateX +
                'px) translateZ(' +
                translateZ +
                'px) rotateY(' +
                rotateY +
                'deg) scale(' +
                scale +
                ')'
            )
        }
      },
      setTransition: function (swiper, transition) {
        for (var i2 = 0; i2 < this.slides.length; i2++) {
          var slide = this.slides.eq(i2)
          slide.transition(transition)
        }
      },
    },
  })

  jQuery(".sp-scroll1").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 6,
    vis: 1,
    scroll: 1,
  });

  jQuery(".sp-scroll2").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  jQuery(".sp-scroll2-b1").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 6,
    vis: 1,
    scroll: 1,
  });
  jQuery(".sp-scroll2-b2").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 6,
    vis: 1,
    scroll: 1,
  });

  jQuery(".sp-scroll4-pc").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  jQuery(".sp-scroll4").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  jQuery(".sp-scroll6").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  jQuery(".sp-scroll6-m").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  let _swiper = new Swiper(".sp-swiper-pro", {
    speed: 1,
    spaceBetween: 0,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
              }
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为

        // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop =
          document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $(".sp-nav").height()
            : targetElement.offsetTop;
        let sptop = document.body.clientWidth <= 1080 ? 60 : 80;

        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            sptop * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        });
      });
    });

    var links_GUARANTEES = document.querySelectorAll('a[href^="#GUARANTEES"]');
    links_GUARANTEES.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为

        // 方式一
        const targetElement = document.getElementById("GUARANTEES"); // 获取跳转目标节点
        const offsetTop =
          document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $(".sp-nav").height()
            : targetElement.offsetTop;
        let sptop = document.body.clientWidth <= 1080 ? -60 : 80;

        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            sptop * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        });
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }

    // 平整的左右滑动轮播
    var carouselSwiper = new Swiper("#carousel .swiper", {
        grabCursor: true,
        centeredSlides: false,
        slidesPerView: 'auto',
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
            reverseDirection: false,
        },
        freeMode: {
            enabled: true,
            momentum: false,
        },
        speed: 5000,
        on: {
            touchEnd: function () {
                var swiper = this;
                setTimeout(function () {
                    swiper.autoplay.stop();
                    swiper.autoplay.start();
                }, 50);
            },
            slideChangeTransitionEnd: function () {
                var swiper = this;
                setTimeout(function () {
                    if (!swiper.autoplay.running) {
                        swiper.autoplay.stop();
                        swiper.autoplay.start();
                    }
                }, 50);
            }
        }
    });

    // 定期检查并重启自动播放
    setInterval(function () {
        if (carouselSwiper && !carouselSwiper.autoplay.running) {
            carouselSwiper.autoplay.start();
        }
    }, 1000);
  }

  mainRender();

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  // 菜单
  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask").click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $(".sp-menu-mask").hide();
    // }
  });

  // 滚动隐藏顶部
  if (
    $(window).scrollTop() >
    $(".sp_header").height() * $("div#root").css("zoom")
  ) {
    $(".sp_header-wrap").addClass("sp-fixed");
  } else {
    $(".sp_header-wrap").removeClass("sp-fixed");
  }

  let spTimer = null;
  let spHasShown = false; // 防止重复显示

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $(".sp_header").height() * $("div#root").css("zoom")
    ) {
      $(".sp_header-wrap").addClass("sp-fixed");
    } else {
      $(".sp_header-wrap").removeClass("sp-fixed");
    }

    // 滚动添加底部
    if (spHasShown) return; // 已经显示就不再触发

    // 如果没有定时器，则开始计时
    if (!spTimer && $(window).scrollTop() > 800) {
      spTimer = setTimeout(function () {
        document.querySelector(".sp-btn-style2").style.display = "flex";
        spHasShown = true; // 标记为已显示
      }, 3000);
    }
  });

  $(document).on("click", ".sp_buy_now", function () {
    console.log("xxx111");
  });

  let initNum = 0;
  $(document).on("click", ".sp_add_cart", function () {
    // 购物车加购动效

    $(this).children("img").addClass("on");
    $(".sp-cart .num").show();
    setTimeout(function () {
      $(" .cart-btn").children("img").removeClass("on");
    }, 500);
    $(" .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-cart").removeClass("on");
    }, 500);

    let spNum = $(".sp_product_part #calcNumber")[0].value;
    initNum += Number(spNum);

    // $("#calcNumber").val(1);

    /* $(".cardNum").each(function () {
      $(this).html(initNum);
    }); */

    const data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
          $('.cardNum').html(result.item_count)
          $('.cardNum').removeClass('sp-gray')
        })
      },
      dataType: 'json',
    })


    var imgs = $(".sp_product_part .swiper-slide-active").find("img");
    // var imgs = $(".sp_product_part .sp-img-p.active");

    imgs.each(function () {
      var $img = $(this);
      var flyer = $img[0].cloneNode(true);
      flyer.classList.add("sp_clone");

      $(".sp_product_part").append(flyer);
      $(flyer).css({
        width: $img[0].width,
        height: $img[0].height,
        background: "#e7e9ef",
        position: "fixed",

        top: $img[0].offsetTop,
        left: $img.offset().left,
        "z-index": 99,
      });
      let finish;
      if (document.body.clientWidth <= 1080) {
        finish = $(".sp-btn-style2 .sp-cart");

        $(flyer).animate(
          {
            top: $(".sp-btn-style2")[0].offsetTop,
            left:
              $(".sp-btn-style2 .sp-area2")[0].offsetLeft + finish.width() / 2 + 458,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      } else {
        finish = $(".sp_pc .sp-cart");
        $(flyer).animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      }
    });
  });

  // 滚动添加底部（首屏不添加，滚动后出现）
  $(window).on("scroll", function () {
    if ($(window).scrollTop() > 0) {
      if (
        $(window).scrollTop() > 0
        // $(".sp-part1").height() * $("div#root").css("zoom") -
        //   $(".sp-part1 .sp-content").height() * $("div#root").css("zoom")
      ) {
        $(".sp-btn-style2").addClass("sp-fixed-bottom");
      } else {
        $(".sp-btn-style2").removeClass("sp-fixed-bottom");
      }
    } else {
      $(".sp-btn-style2").removeClass("sp-fixed-bottom");
    }
  });

  // 问答
  $('.sp-qa3-question').on('click', function() {
      var $currentItem = $(this).closest('.sp-qa3-item');
      var $answer = $currentItem.find('.sp-qa3-answer');

      if ($currentItem.hasClass('active')) {
          $answer.slideUp(300);
          $currentItem.removeClass('active');
      } else {
          $('.sp-qa3-item').removeClass('active');
          $('.sp-qa3-answer').slideUp(300);
          $currentItem.addClass('active');
          $answer.slideDown(300);
      }
  });

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`;
              span.style.animationDelay = `${index * 0.3 + 1}s`;
            });

            observerAni.unobserve(gradually3);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually3);
  }
});
